export const HALLOWEEN_MODE = true;
